import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';

import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from "@ngx-translate/core";
import { LaddaModule } from 'angular2-ladda';

import { ReviewsRoutingModule } from './reviews-routing.module';
import { SharedModule } from 'src/app/shared/shared.module';

import {
  ReviewsMainComponent,
} from './containers';
import {
  ReviewsTableComponent,
  UpdateReviewPopupComponent,
  ReviewDetailsPopupComponent,
  ReviewsFiltersComponent,
  SelectPlatformComponent,
  SelectRatingComponent,
  SelectCompanyAssociatedComponent
} from './components';

@NgModule({
    declarations: [
        ReviewsMainComponent,
        ReviewsTableComponent,
        UpdateReviewPopupComponent,
        ReviewDetailsPopupComponent,
        ReviewsFiltersComponent,
        SelectPlatformComponent,
        SelectRatingComponent,
        SelectCompanyAssociatedComponent
    ],
    imports: [
        NgbModule,
        ReviewsRoutingModule,
        CommonModule,
        ReactiveFormsModule,
        FormsModule,
        NgxSkeletonLoaderModule,
        TranslateModule.forChild(),
        LaddaModule.forRoot({
            spinnerColor: 'grey',
            style: 'zoom-in'
        }),
        SharedModule
    ],
    providers: [
        DatePipe
    ]
})
export class ReviewsModule { }
